import { Outlet } from 'react-router-dom';
import MainNavbar from './MainNavbar.tsx';
import { SidebarProvider } from '../../context/SidebarContext.tsx';
import type { MainNavbarProps } from './MainNavbar.tsx';

interface LayoutProps extends MainNavbarProps {}

const Layout = (props: LayoutProps) => {
  return (
    <SidebarProvider>
      <div className="flex flex-col min-h-screen">
        {/* Fixed navbar at top */}
        <MainNavbar {...props} />

        {/* Main content area */}
        <main className="flex-1 overflow-auto bg-gray-50">
          <Outlet />
        </main>
      </div>
    </SidebarProvider>
  );
};

export default Layout;
